export const NAME = 'loads-and-wind-modal';
